export enum NotesActionEnum {
  GET_NOTES = 'GET_NOTES',
}
